import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../core/auth/account.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-monthly-visitors',
  standalone: false,
  templateUrl: './monthly-visitors.component.html',
  styleUrl: './monthly-visitors.component.scss',
})
export class MonthlyVisitorsComponent implements OnInit {
  data: any;
  options: any;
  private chartColors = {
    accent: '#db2a22',
    accentSoft: 'rgba(219, 42, 34, 0.18)',
    textPrimary: '#f6f6f6',
    textMuted: '#b7bcc4',
    grid: '#3d404a',
  };

  constructor(
    private accountService: AccountService,
    private router: Router
  ) {
    this.applyTheme();
  }

  ngOnInit(): void {
    this.accountService.identity().subscribe((res) => {
      const account = res;
      if (account === null) this.router.navigate(['/account/login']);
    });

    this.accountService.getVisitorsDuringTheMonth().subscribe((data) => {
      const lLabels: number[] = [];
      const lData: number[] = [];
      data.data.forEach((obj) => {
        lLabels.push(obj.day);
        lData.push(obj.visits);
      });

      this.data = {
        labels: lLabels,
        datasets: [
          {
            label: '',
            data: lData,
            fill: true,
            borderColor: this.chartColors.accent,
            backgroundColor: this.chartColors.accentSoft,
            tension: 0.35,
            pointBorderColor: this.chartColors.accent,
            pointBackgroundColor: this.chartColors.accent,
            pointRadius: 3,
            pointHoverRadius: 5,
            borderWidth: 2,
          },
        ],
      };
    });
  }

  private applyTheme(): void {
    const accent = this.getCssVar('--color-primary', this.chartColors.accent);
    const accentAlt = this.getCssVar('--brand-accent', accent);
    const textPrimary = this.getCssVar('--text-primary', this.chartColors.textPrimary);
    const textMuted = this.getCssVar('--text-secondary', this.chartColors.textMuted);
    const gridBase = this.getCssVar('--table-border', this.chartColors.grid);
    const grid = this.hexToRgba(gridBase, 0.45);

    this.chartColors = {
      accent,
      accentSoft: this.hexToRgba(accentAlt, 0.2),
      textPrimary,
      textMuted,
      grid,
    };

    this.options = {
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        intersect: false,
        mode: 'index' as const,
      },
      plugins: {
        legend: {
          display: false,
        },
        title: {
          display: false,
        },
      },
      scales: {
        x: {
          ticks: {
            color: this.chartColors.textMuted,
            beginAtZero: true,
            maxTicksLimit: 31,
            padding: 12,
          },
          grid: {
            display: true,
            color: this.chartColors.grid,
            borderColor: this.chartColors.grid,
          },
        },
        y: {
          ticks: {
            color: this.chartColors.textMuted,
            beginAtZero: true,
            maxTicksLimit: 10,
            padding: 12,
          },
          grid: {
            display: true,
            color: this.chartColors.grid,
            borderColor: this.chartColors.grid,
          },
        },
      },
    };
  }

  private getCssVar(name: string, fallback: string): string {
    if (typeof document === 'undefined') {
      return fallback;
    }
    const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return value || fallback;
  }

  private hexToRgba(value: string, alpha: number): string {
    const hex = value.replace('#', '').trim();
    if (hex.length !== 6) {
      return value;
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
}
